// extracted by mini-css-extract-plugin
export default {"features":"Features_features__c6s3C","title":"Features_title__UkIUN","cards":"Features_cards__cNkvf","card":"Features_card__LN+u9"};